app.factory('callToActionRegistrationSessionService', function($sessionStorage) {
    var storage = $sessionStorage.$default({
        showCallToActionRegister: true
    }); 

    return {
        get showCallToActionRegister() {
            return storage.showCallToActionRegister;
        },
        callToActionRegisterStateTrigger: function($event) {
            if($event && $event.preventDefault) {
                $event.preventDefault();
            }
            storage.showCallToActionRegister = false;
        }
    };
});